import type { Message } from '../types/index.js'

function replaceAt(messages: Message[], index: number, message: Message): Message[] {
  return messages.map((current, currentIndex) => currentIndex === index ? message : current)
}

function findLastIndex(messages: Message[], predicate: (message: Message) => boolean): number {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index]
    if (message && predicate(message)) return index
  }
  return -1
}

export function mergePlatformMessage(messages: Message[], message: Message): Message[] {
  const exactIndex = messages.findIndex(current => current.id === message.id)
  if (exactIndex >= 0) return replaceAt(messages, exactIndex, message)

  const optimisticIndex = findLastIndex(messages, current => {
    if (message.role === 'user') {
      return current.role === 'user' && current.id.startsWith('user_') && current.content === message.content
    }
    if (message.role === 'assistant') {
      return current.role === 'assistant' && current.id.startsWith('streaming_')
    }
    return false
  })
  if (optimisticIndex >= 0) return replaceAt(messages, optimisticIndex, message)

  return [...messages, message]
}

export function updatePlatformMessage(messages: Message[], message: Message): Message[] {
  const exactIndex = messages.findIndex(current => current.id === message.id)
  if (exactIndex >= 0) return replaceAt(messages, exactIndex, message)
  return mergePlatformMessage(messages, message)
}

export function deletePlatformMessage(messages: Message[], message: Pick<Message, 'id'>): Message[] {
  return messages.filter(current => current.id !== message.id)
}
